import { createSlice } from '@reduxjs/toolkit';

const encyclopediaSlice = createSlice({
  name: 'encyclopedia',
  initialState: {
    checkedItems: [], // Lista zaznaczonych artykułów (IDs)
    activeEncyclopediaTab: 'Encyklopedia', // Domyślna aktywna zakładka
    currentPage: 1, // Domyślna strona (1-indexed)
    maxPages: 1, // Domyślna maksymalna liczba stron
    sortBy: 'createdAt',
    sortDirection: 'DESC', // Domyślny kierunek sortowania
    searchQuery: null, // Ogólne wyszukiwanie
    searchValue: '', // Wartość wyszukiwania
    // Filtry
    title: null,
    dateFrom: null,
    dateTo: null,
    address: null,
    authorName: null,
    userId: null,
    pinUrl: null,
    status: null,
    totalCount: 0, // Całkowita liczba artykułów
    // Detail view
    selectedArticle: null,
    showDetailView: false,
    showAddModal: false,
    showEditModal: false,
    detailViewTab: 'Dane podstawowe', // 'Dane podstawowe' lub 'Opis'
  },
  reducers: {
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload;
    },
    toggleCheckedItem: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        state.checkedItems.push(id);
      }
    },
    setActiveEncyclopediaTab(state, action) {
      state.checkedItems = [];
      state.activeEncyclopediaTab = action.payload;
      state.currentPage = 1;
    },
    setPage(state, action) {
      state.checkedItems = [];
      state.currentPage = action.payload;
    },
    setMaxPages(state, action) {
      state.maxPages = action.payload;
    },
    setSorting(state, action) {
      state.checkedItems = [];
      const { sortBy, sortDirection } = action.payload;
      state.sortBy = sortBy;
      state.sortDirection = sortDirection;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
      state.currentPage = 1;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
      state.currentPage = 1;
    },
    setDateFrom(state, action) {
      state.dateFrom = action.payload;
      state.currentPage = 1;
    },
    setDateTo(state, action) {
      state.dateTo = action.payload;
      state.currentPage = 1;
    },
    setAddress(state, action) {
      state.address = action.payload;
      state.currentPage = 1;
    },
    setAuthorName(state, action) {
      state.authorName = action.payload;
      state.currentPage = 1;
    },
    setUserId(state, action) {
      state.userId = action.payload;
      state.currentPage = 1;
    },
    setPinUrl(state, action) {
      state.pinUrl = action.payload;
      state.currentPage = 1;
    },
    setStatus(state, action) {
      state.status = action.payload;
      state.currentPage = 1;
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    setSelectedArticle(state, action) {
      state.selectedArticle = action.payload;
    },
    setShowDetailView(state, action) {
      state.showDetailView = action.payload;
    },
    setShowAddModal(state, action) {
      state.showAddModal = action.payload;
    },
    setShowEditModal(state, action) {
      state.showEditModal = action.payload;
    },
    setDetailViewTab(state, action) {
      state.detailViewTab = action.payload;
    },
    clearFilters(state) {
      state.searchQuery = null;
      state.searchValue = '';
      state.title = null;
      state.dateFrom = null;
      state.dateTo = null;
      state.address = null;
      state.authorName = null;
      state.userId = null;
      state.pinUrl = null;
      state.status = null;
      state.currentPage = 1;
    },
  },
});

export const {
  setCheckedItems,
  toggleCheckedItem,
  setActiveEncyclopediaTab,
  setPage,
  setMaxPages,
  setSorting,
  setSearchQuery,
  setSearchValue,
  setTitle,
  setDateFrom,
  setDateTo,
  setAddress,
  setAuthorName,
  setUserId,
  setPinUrl,
  setStatus,
  setTotalCount,
  setSelectedArticle,
  setShowDetailView,
  setShowAddModal,
  setShowEditModal,
  setDetailViewTab,
  clearFilters,
} = encyclopediaSlice.actions;

export default encyclopediaSlice.reducer;




